import React from 'react';
import { Order } from '../../models/Order';
import { StatePrescriptionLog } from '../../models/StatePrescriptionLog';
import { StatePrescriptionIdentification } from '../../enums/StatePrescriptionIdentification';
import { BadgeTitled } from '../../common-components/BadgeTitled/BadgeTitled';

export interface IAssemblyStatusProps {
  order?: Order;
  statePrescriptionLog?: StatePrescriptionLog;
}

export const AssemblyStatus: React.FC<IAssemblyStatusProps> = ({
  order,
  statePrescriptionLog
}) => {

  const isAssembly = (
    statePrescriptionLog?.currentStateId === StatePrescriptionIdentification.AguardandoMontagemInterna ||
    statePrescriptionLog?.currentStateId === StatePrescriptionIdentification.AguardandoMontagemExterna ||
    statePrescriptionLog?.currentStateId === StatePrescriptionIdentification.AguardandoConferencia ||
    statePrescriptionLog?.currentStateId === StatePrescriptionIdentification.Ok
  );

  if (!isAssembly) return null;

  const totalPrescriptionItems = (order?.totalLensesCount || 0) + (order?.totalFramesCount || 0);

  return (
    <>
      <BadgeTitled title='Lentes e Armações' text={`${totalPrescriptionItems || '0'}`} />
      <BadgeTitled title='Lentes' text={`${order?.totalLensesCount || '0'}`} />
      <BadgeTitled title='Armações' text={`${order?.totalFramesCount || '0'}`} />
      <BadgeTitled title='Recebido Montador' text={`${order?.totalLensesAndFramesReceivedByAssembler || '0'}`} />
      <BadgeTitled title='Montando' text={`${order?.totalLensesAndFramesInAssembly || '0'}`} />
      <BadgeTitled title='Montado' text={`${order?.totalLensesAndFramesAssembled || '0'}`} />
      <BadgeTitled title='Enviado para Loja' text={`${order?.totalLensesAndFramesSentToStoreByAssembler || '0'}`} />
    </>
  );

}